/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */
import { translations } from 'locales/translations';
import { _t } from 'utils/messages';

export const messages = {
  home: () => _t(translations.home),
  corporateUserInformationRegistration: () =>
    _t(
      translations.corporateUserRegistration
        .corporateUserInformationRegistration,
      'Corporate User Information Registration',
    ),
  corporateId: () =>
    _t(translations.corporateUserRegistration.corporateIdUser, 'Corproate ID'),
  corporateUserEmailID: () =>
    _t(
      translations.corporateUserRegistration.corporateUserEmailID,
      'User ID (Email Address)',
    ),
  corporateUserEmailIDPlaceholder: () =>
    _t(
      translations.corporateUserRegistration.corporateUserEmailIDPlaceholder,
      'Email Address',
    ),
  corporateUserType: () =>
    _t(
      translations.corporateUserRegistration.corporateUserType,
      'Corporate User Type',
    ),
  username: () =>
    _t(translations.corporateUserRegistration.username, 'Username'),
  pseudonymName: () =>
    _t(translations.corporateUserRegistration.pseudonymName, 'Pseudonym Name'),
  password: () =>
    _t(translations.personInChargePasswordPlaceholder, 'Password'),
  confirmPassword: () =>
    _t(translations.personInChargeConfirmPlaceholder, 'Confirm Password'),
  departmentInCharge: () =>
    _t(translations.departmentInChargeLabel, 'Department In Charge'),
  departmentInChargePlaceholder: () =>
    _t(translations.departmentInChargePlaceholder, 'Department Name'),
  contactTelephone: () =>
    _t(
      translations.corporateUserRegistration.contactTelephone,
      'Contact (Telephone)',
    ),
  avatarImage: () => _t(translations.avatarImage, 'Avatar Image'),
  browseImage: () => _t(translations.browseImage, 'Browse Image...'),
  browseFiles: () => _t(translations.browseFiles, 'Browse Files'),
  registerButtonLabel: () => _t(translations.registerButtonLabel, 'Register'),
  resetButtonLabel: () => _t(translations.resetButtonLabel, 'Reset'),
  confirmButtonLabel: () => _t(translations.confirmButtonLabel, 'Confirm'),
  backButtonLabel: () => _t(translations.backButtonLabel, 'Back'),
  searchCorporateUser: () =>
    _t(
      translations.corporateUserRegistration.searchCorporateUser,
      'Search Corporate User',
    ),
  userManagement: () =>
    _t(translations.userManagement.userManagement, 'User Management'),
  inUse: () =>
    _t(translations.corporateUserRegistration.corporateStatus.inUse, 'In Use'),
  cancellation: () =>
    _t(
      translations.corporateUserRegistration.corporateStatus.cancellation,
      'Cancelled',
    ),
  suspensionOfservice: () =>
    _t(
      translations.corporateUserRegistration.corporateStatus
        .suspensionOfservice,
      'Suspension of Service Use',
    ),
  corporateUserId: () =>
    _t(
      translations.corporateUserRegistration.corporateUserId,
      'Corporate User ID',
    ),
  userName: () =>
    _t(translations.corporateUserRegistration.username, 'Username'),
  corporateIdLabel: () =>
    _t(translations.corporateUserRegistration.corporateID, 'Corporate Id'),
  userAuthority: () =>
    _t(translations.corporateUserRegistration.userAuthority, 'User Authority'),
  corporateStatus: () =>
    _t(
      translations.corporateUserRegistration.corporateStatus.status,
      'Corporate Status',
    ),
  actions: () => _t(translations.corporateUserRegistration.actions, 'Actions'),
  noDataFound: () => _t(translations.noDataFound, '"No Data Found'),
  searchPlaceHolder: () =>
    _t(
      translations.searchCorporatePlaceholder,
      'Search by Corporate ID or Name',
    ),
  initialRegistrationDate: () =>
    _t(translations.initialRegistrationDate, 'Initial Registration Date'),
  lastUpdatedDate: () => _t(translations.lastUpdatedDate, 'Last Updated Date'),
  lastUpdatedUserID: () =>
    _t(translations.lastUpdatedUserID, 'Last Updated User ID'),
};
